import React from 'react';
import { Carousel } from 'antd';

interface CommonSliderProps {
  images?: string[];
  autoPlay?: boolean;
  showDots?: boolean;
  className?: string;
}

const CommonSlider: React.FC<CommonSliderProps> = ({
  images = [],
  autoPlay = true,
  showDots = true,
  className = ''
}) => {
  if (!images.length) {
    return (
      <div className={`w-full h-48 bg-gray-200 flex items-center justify-center ${className}`}>
        <span className="text-gray-500">No images available</span>
      </div>
    );
  }

  const settings = {
    dots: showDots,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: autoPlay,
    autoplaySpeed: 3000,
    arrows: true,
  };

  return (
    <div className={`w-full ${className}`}>
      <Carousel {...settings}>
        {images.map((image, index) => (
          <div key={index} className="w-full">
            <img
              src={image}
              alt={`Slide ${index + 1}`}
              className="w-full h-auto object-cover"
              loading="lazy"
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default CommonSlider;
